import { render, staticRenderFns } from "./OrganizationsRow.vue?vue&type=template&id=535b85ca"
import script from "./OrganizationsRow.vue?vue&type=script&lang=js"
export * from "./OrganizationsRow.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsRow.vue?vue&type=style&index=0&id=535b85ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports